function weather(state = {}, action) {
  switch(action.type) {
    case 'WEATHER_FETCHED':
      // console.log('======WEATHER_FETCHED=======SUCCESS')
      return action.result;
    default:
      // console.log('======WEATHER_FETCHED=======DEFAULT')
      return state;
  }
}

export default weather;



// WEBPACK FOOTER //
// ./src/reducers/weather.js